<template>
  <div class="container mt-100">
    <div class="tw-grid tw-grid-cols-12 tw-items-center">
      <div class="tw-col-span-12 tw-pb-6 lg:tw-col-span-7 lg:tw-pb-0">
        <h2 class="font-plus-jakarta-semibold tw-mb-7 tw-text-3xl lg:tw-mb-12 lg:tw-text-4xl">
          {{ vars.titleText }}
        </h2>
        <p v-html="vars.descriptionText" />
      </div>
      <div class="tw-col-span-1"></div>
      <div class="tw-col-span-12 lg:tw-col-span-4">
        <div
          class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-12 tw-rounded-md tw-px-12 tw-py-16"
          :style="`background-color: var(--${vars.cardBackgroundColor})`"
        >
          <div class="font-arial-bold tw-rounded-full tw-bg-white tw-px-5 tw-py-3 tw-text-sm">
            {{ vars.cardLabelText }}
          </div>
          <NuxtImg
            :src="vars.cardIcon"
            class="icon"
            width="100"
            height="100"
            :alt="vars.titleText"
            :title="vars.TitleText"
          />
          <div class="tw-text-center tw-text-white">
            <h2 class="font-arial-bold tw-mb-6 tw-text-2xl">
              {{ vars.cardTitleText }}
            </h2>
            <p>
              {{ vars.cardDescriptionText }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'BestPackage',

  mixins: [ComponentMixin],
});
</script>

<style scoped>
.pxp-plans-1-item:hover {
  border: none;
}
.pxp-plans-1-item:hover .pxp-plans-1-item-title {
  transform: translateY(-42px) scale(1.1);
  color: white;
}
.pxp-plans-1-item:hover .pxp-plans-1-item-price {
  color: white;
}

img.icon {
  filter: invert(100%) sepia(1%) saturate(343%) hue-rotate(156deg) brightness(118%) contrast(100%);
}
</style>
